<now-wbsuche-lib-dropdown
  id="sortierung_mobile"
  [possibleValues]="mobileSortableColumns"
  [label]="messages.SORTIEREN_NACH"
  [optionLabelFunction]="sortDropdownLabel"
  [optionCompareFunction]="optionCompareFunction"
  (selectionChanged)="selectionChanged($event)"
  [selectedValue]="selectedValue"
>
</now-wbsuche-lib-dropdown>
